class JobSearch {
  suggestedJobs: Array<{ name: string; }>;

  jobInputs: NodeListOf<HTMLInputElement>;

  selectedJobInputs: NodeListOf<HTMLInputElement>;

  forms: NodeListOf<HTMLFormElement>;

  resultsContainers: NodeListOf<HTMLElement>;

  isValidSelection: boolean;

  errorContainers: Map<HTMLFormElement, HTMLElement>;

  constructor() {
    this.suggestedJobs = [];
    this.jobInputs = document.querySelectorAll('.job-search-query');
    this.selectedJobInputs = document.querySelectorAll('.selected-job');
    this.forms = document.querySelectorAll('.job-search-form');
    this.resultsContainers = document.querySelectorAll('.job-search-form-results');
    this.isValidSelection = false;
    this.errorContainers = new Map();

    // Initialize error containers for each form
    for (const form of this.forms) {
      const resultsContainer = form.querySelector('.job-search-form-results');
      let errorContainer = form.querySelector('.error-dropdown') as HTMLElement;

      if (!errorContainer) {
        errorContainer = document.createElement('div');
        errorContainer.classList.add('error-dropdown');
        errorContainer.style.display = 'none';
        if (resultsContainer) {
          resultsContainer.parentNode!.insertBefore(errorContainer, resultsContainer);
        }
      }

      this.errorContainers.set(form, errorContainer);
    }

    // Clear inputs on load
    this.clearSearchFields();

    // Clear inputs on back navigation
    window.addEventListener('popstate', () => this.clearSearchFields());

    // Clear inputs if page is restored from cache
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        this.clearSearchFields();
      }
    });
  }

  clearSearchFields() {
    for (const input of this.jobInputs) {
      input.value = '';
    }
    for (const input of this.selectedJobInputs) {
      input.value = '';
    }
    this.isValidSelection = false;
  }

  buildDropdown(targetForm: HTMLFormElement) {
    const jobs = this.suggestedJobs;
    const jobInput = targetForm.querySelector('.job-search-query') as HTMLInputElement;
    const query = jobInput.value.trim().toLowerCase();
    const registrationType = targetForm.dataset.registrationType || 'decouverte';

    const dropdown = document.createElement('div');
    dropdown.classList.add('dropdown');
    dropdown.innerHTML = `
      <ul class="" aria-labelledby="dropdownMenuButton">
        ${jobs
    .map((job) => {
      const regex = new RegExp(`(${query})`, 'gi');
      const highlightedName = job.name.replace(regex, '<em>$1</em>');

      return `
              <li>
                <a class="dropdown-item job-option" href="/app/register/1/?job=${job.name}&type=${registrationType}" data-name="${job.name}" data-type="${registrationType}">
                  ${highlightedName}
                </a>
              </li>
            `;
    })
    .join('')}
      </ul>
    `;

    for (const item of dropdown.querySelectorAll('.job-option')) {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        let target = event.target as HTMLElement;

        if (target.tagName === 'EM') {
          target = target.closest('.job-option') as HTMLElement;
        }

        const jobName = target.dataset.name;
        const regType = target.dataset.type;

        if (jobName) {
          jobInput.value = jobName;
          const selectedJobInput = targetForm.querySelector('.selected-job') as HTMLInputElement;
          if (selectedJobInput) {
            selectedJobInput.value = jobName;
          }
          this.isValidSelection = true;
          this.clearError(targetForm);
          this.emptyDropdown(targetForm);

          history.pushState({}, '', window.location.href);
          window.location.href = `/app/register/1/?job=${jobName}&type=${regType}`;
        }
      });
    }

    return dropdown;
  }

  emptyDropdown(targetForm: HTMLFormElement) {
    const results = targetForm.querySelector('.job-search-form-results');
    if (results) {
      results.innerHTML = '';
      this.suggestedJobs = [];
    }
  }

  handleJobSearch() {
    for (const jobInput of this.jobInputs) {
      jobInput.addEventListener('keyup', (event) => {
        event.preventDefault();
        const query = jobInput.value.trim();
        const targetForm = jobInput.closest('.job-search-form') as HTMLFormElement;
        this.isValidSelection = false;

        if (query.length < 3) {
          this.emptyDropdown(targetForm);
          return;
        }

        const url = `/api/jobs/search/?term=${query}`;

        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            if (data.hits.length === 0) {
              this.emptyDropdown(targetForm);
              return;
            }

            this.suggestedJobs = data.hits;

            const dropdown = this.buildDropdown(targetForm);
            const results = targetForm.querySelector('.job-search-form-results');

            if (results) {
              results.innerHTML = '';
              results.append(dropdown);
            }
          });
      });
    }
  }

  preventInvalidSubmission() {
    for (const form of this.forms) {
      form.addEventListener('submit', (event) => {
        const jobInput = form.querySelector('.job-search-query') as HTMLInputElement;
        const inputValue = jobInput.value.trim();
        const matchedJob = this.suggestedJobs.find((job) => job.name.toLowerCase() === inputValue.toLowerCase());
        const registrationType = form.dataset.registrationType || 'decouverte';

        if (!this.isValidSelection && !matchedJob) {
          event.preventDefault();
          this.displayError(form, 'Veuillez sélectionner un métier dans la liste des suggestions avant de valider.');
        } else if (matchedJob) {
          event.preventDefault();
          history.pushState({}, '', window.location.href);
          window.location.href = `/app/register/1/?job=${matchedJob.name}&type=${registrationType}`;
        }
      });
    }
  }

  displayError(targetForm: HTMLFormElement, message: string) {
    const errorContainer = this.errorContainers.get(targetForm);
    if (errorContainer) {
      errorContainer.innerHTML = `<p class="error-message">${message}</p>`;
      errorContainer.style.display = 'block';
    }
  }

  clearError(targetForm: HTMLFormElement) {
    const errorContainer = this.errorContainers.get(targetForm);
    if (errorContainer) {
      errorContainer.innerHTML = '';
      errorContainer.style.display = 'none';
    }
  }

  scrollToForm() {
    for (const form of this.forms) {
      const jobInput = form.querySelector('.job-search-query') as HTMLInputElement;
      if (jobInput) {
        jobInput.addEventListener('focus', () => {
          window.scrollTo(0, form.offsetTop - 120);
        });
      }
    }
  }
}

window.addEventListener('load', () => {
  if (document.querySelector('.job-search-query')) {
    const jobSearch = new JobSearch();
    jobSearch.handleJobSearch();
    jobSearch.preventInvalidSubmission();
    jobSearch.scrollToForm();
  }
});
